import AppToggle from './AppToggle.vue';
export default AppToggle;



// WEBPACK FOOTER //
// ./src/uikit/components/AppToggle/index.ts